import { create } from "zustand";
import { persist } from "zustand/middleware";

const useUserStore = create(
	persist(
		(set) => ({
			user: {
				user_id: null,
				customer_id: null,
				name: "",
				customer_name: "",
				superuser: 0,
			},

			setUser: (newUser) => set({ user: newUser }),

			resetUser: () =>
				set({
					user: {
						user_id: null,
						customer_id: null,
						name: "",
						customer_name: "",
						superuser: 0,
					},
				}),
		}),
		{
			name: "agroinventario-user-storage",
		},
	),
);

export default useUserStore;
